//Keeping this file at the moment to so that we can use it for dropdown menu
/**
 * @fileOverview File with Portal Header Links component
 * @description File containing PortalHeaderLinks function
 * @author Komal Chevli
 * @since 1.0.0
 */

import React from "react";
import { Link } from "react-router-dom";
import { accountTypesConstants } from '../../constants';
import * as token from '../../helpers/token';
import { gisRoutes } from '../../routes/routes'
import * as HeaderLinks from '../../constants/headerlinks.constants';
import { categoryGroupBy, permissionFinder } from '../../helpers/util';
//phrasebook
import phrasebookLoad from "../../i18n";
const phrasebook = phrasebookLoad()


// We need to load the header according to the logged user.
// So... if is admin user, will have( for now)
// accounts, notifications, administration
const Logo = props => {
  if (token.loggedAccountType()) {
    let url = undefined;
    url = gisRoutes.dashboard[accountTypesConstants[token.loggedAccountType()]];
    return <Link to={url}><img src={props.image} alt="" /></Link>
  } else return null;
}

const PortalHeaderLinks = props => <div className="nav-bar">
  <button className="btn btn-nav-toggle"></button>
  <h1 className="logo">
    <a href="https://www.pccwglobal.com/" target="_blank">
      <img src="https://skyframework.pccwglobal.com/img/pccwglobal.svg" />
    </a>
  </h1>
  <h1 className="logo">
    <Logo image={props.image} />
  </h1>

  <div className="mobile-nav">
    <ul className="nav nav-left">
      <HeaderDropdown routes={props.routes} />
    </ul>

    <ul className="nav nav-right nav-icons" key="">
      <li class="dropdown">
        <Link class="btn-dropdown-toggle" to="/portal/downloads">
          <span>{phrasebook.headerlinks.downloads}</span><i class="sky-icon-folder-open-o"></i>
          <>{props.filesdownload && props.filesdownload.count ? <sup class="badge">{props.filesdownload.count}</sup> : null}</>
        </Link>

      </li>
      <li class="dropdown">
        <Link class="btn-dropdown-toggle" to="/portal/notification/notifications">
          <span>{phrasebook.notifications.notifications}</span><i class="sky-icon-notifications"></i>
          <>{props.newNotifications && props.newNotifications.count ? <sup class="badge">{props.newNotifications.count}</sup> : null}</>
        </Link>

      </li>
      {token.loggedAccountType() && token.loggedAccountType() == 100 ? <li class="dropdown">
        <Link class="btn-dropdown-toggle" to="/portal/administration/configuration/edit">
          <span>{phrasebook.headerlinks.configuration}</span><i class="sky-icon-settings"></i>
        </Link>
      </li> : null}
      <li className="dropdown">
        <a href="#" className="btn-dropdown-toggle" data-toggle="dropdown">
          <span>My account</span>
          <i className="sky-icon-account_circle"></i></a>
        <ul className="dropdown-menu">
          <IconList routes={props.routes} />
          <li><Link to="/account/logout">{phrasebook.login_view.logout}</Link></li>
        </ul>
      </li>
    </ul>
    {/* {token.loggedAccountType() === 100 ?
      <ul className="nav nav-right">
        <li className="dropdown">
          <a href="#" className="btn-dropdown-toggle" data-toggle="dropdown">
            <span>{phrasebook.headerlinks.view_team}</span>
          </a>
          <ul className="dropdown-menu">
            <TeamList routes={props.routes} />
          </ul>
        </li>
      </ul> : null} */}

  </div>
</div>

const HeaderDropdown = props => {
  if (token.loggedPermissions()) return HeaderLinks.HeaderDropDown.map(header => {
    if (header.always == true) {
      const listLinks = props.routes.filter(link => link.category === header.id);
      if (listLinks.length > 0) return <li class="dropdown">
        <a className="btn-dropdown-toggle" data-toggle="dropdown"><span>{header.label}</span></a>
        <ul className="dropdown-menu">
          <HeaderList routes={props.routes} category={header.id} />
        </ul>
      </li>
      // const listLinks = props.routes.filter(link => link.category === header.id);
      // return <li class="dropdown">
      //   <a className="btn-dropdown-toggle" data-toggle="dropdown"><span>{header.label}</span></a>
      //   <ul className="dropdown-menu">
      //     {listLinks.map(list => {
      //       return <li><Link to={list.path}>{list.name}</Link></li>
      //     })}
      //   </ul>
      // </li>
    }
    else {
      return categoryGroupBy(token.loggedPermissions()).map(category => {
        const listLinks = props.routes.filter(link => link.category === category);
        if (header.id == category && listLinks.length > 0) return <li class="dropdown">
          <a className="btn-dropdown-toggle" data-toggle="dropdown"><span>{header.label}</span></a>
          <ul className="dropdown-menu">
            <HeaderList routes={props.routes} category={category} />
          </ul>
        </li>
        else return null
      })
    }

  }
  )
  else return null
}

const HeaderList = props => {
  const listLinks = props.routes.filter(link => link.category === props.category);

  return listLinks.map(list => {
    if (list.pccwglobal_only) {
      if (token.loggedAccountType() < 200) {
        if (list.show_always || (permissionFinder(token.loggedPermissions(), token.loggedAccountType(), list.restrictedFunction, list.action, token.loggedToken()))) return <li><Link to={list.path}>{list.name}</Link></li>
        else return null
      } else return null
    }
    else if (list.customers_only) {
      if (token.loggedAccountType() >= 200) {
        if (list.show_always || permissionFinder(token.loggedPermissions(), token.loggedAccountType(), list.restrictedFunction, list.action, token.loggedToken())) return <li><Link to={list.path}>{list.name}</Link></li>
        else return null
      } else return null
    }
    else
      if (permissionFinder(token.loggedPermissions(), token.loggedAccountType(), list.restrictedFunction, list.action, token.loggedToken())) {
        return <li><Link to={list.path}>{list.name}</Link></li>
      }
      else return null;
  });
}
// const props.routes.filter(link => link.category === props.category ).map(list => <>{permissionFinder(token.loggedPermissions(), token.loggedAccountType(), list.restrictedFunction, list.action, token.loggedToken()) ? <li><Link to={list.path}>{list.name}</Link></li> : null}</>
// )

const IconList = props => props.routes.filter(link => link.type === 'icon')
  .map(icon => <li><Link to={icon.path}>{icon.name}</Link></li>)

const TeamList = props => props.routes.filter(link => link.type === 'team')
  .map(icon => <li><Link to={icon.path}>{icon.name}</Link></li>)

const NotificationList = props => props.routes.filter(link => link.type === 'notification')
  .map(notification => <li><Link to={notification.path}>{notification.name}</Link></li>)

export default PortalHeaderLinks
